import ButtonGroup from '@atlaskit/button/button-group';

import IconButton from '@atlaskit/button/icon/button';

import LinkIconButton from '@atlaskit/button/icon/link';

import Heading from '@atlaskit/heading/heading';

import CrossIcon from '@atlaskit/icon/core/cross';

import LinkExternalIcon from '@atlaskit/icon/core/link-external';

import Modal from '@atlaskit/modal-dialog/modal-dialog';

import ModalTitle from '@atlaskit/modal-dialog/modal-title';

import { fg } from '@atlaskit/platform-feature-flags/fg';

import { Box } from '@atlaskit/primitives/box';

import { Inline } from '@atlaskit/primitives/inline';

import { xcss } from '@atlaskit/primitives/xcss/xcss';

import {
	OrangeDamEmbeddedVideoPlayer,
	buildOrangeDamUrl,
} from '@post-office/components--embedded-video-player';

import { FormattedMessage, defineMessages, useIntl } from 'react-intl';

import { type JSX } from 'react/jsx-runtime';

type VideoModalProps = {
	onClose: () => void;
};

const VIDEO_ID = '3e23o683507bakt2y785a1j4bp00d2sa';

const VIDEO_WIDTH = 1000;

const VIDEO_HEIGHT = 1000 / (16 / 9);

const modalContainer = xcss({
	display: 'flex',
	flexDirection: 'column',
	overflow: 'scroll',
	gap: 'space.200',
});

export const VideoModal = (props: VideoModalProps): JSX.Element => {
	const intl = useIntl();
	const { onClose } = props;

	const titleContent = <FormattedMessage {...messages.videoModalTitle} />;

	return (
		<Modal
			onClose={onClose}
			testId="twc-getting-started-video-modal"
			width="xlarge"
			height="xlarge"
		>
			<Box padding="space.300" xcss={modalContainer} testId="twc-video-modal-content">
				<Inline spread="space-between" alignBlock="center">
					{fg('platform_dst-modal_title') ? (
						<ModalTitle>
							<Heading size="medium" as="span">
								{titleContent}
							</Heading>
						</ModalTitle>
					) : (
						<Heading size="medium">{titleContent}</Heading>
					)}
					<ButtonGroup>
						<LinkIconButton
							appearance="subtle"
							href={buildOrangeDamUrl({ videoId: VIDEO_ID })}
							icon={LinkExternalIcon}
							label={intl.formatMessage(messages.externalLinkButtonLabel)}
							target="_blank"
							rel="noopener noreferrer"
						/>
						<IconButton
							onClick={onClose}
							appearance="subtle"
							icon={CrossIcon}
							label={intl.formatMessage(messages.closeButtonLabel)}
							testId="twc-video-modal-close"
						/>
					</ButtonGroup>
				</Inline>
				<OrangeDamEmbeddedVideoPlayer
					height={VIDEO_HEIGHT}
					width={VIDEO_WIDTH}
					videoId={VIDEO_ID}
					autoplay
				/>
			</Box>
		</Modal>
	);
};

const messages = defineMessages({
	videoModalTitle: {
		defaultMessage: 'Welcome to Atlassian',
		description: 'Title for a modal containing getting started video',
		id: 'townsquare.twc-onboarding-widget.twc-card.modal-title',
	},
	externalLinkButtonLabel: {
		defaultMessage: 'Open link',
		description: 'Label for button to open video in another tab',
		id: 'townsquare.twc-onboarding-widget.twc-card.modal-external-link',
	},
	closeButtonLabel: {
		defaultMessage: 'Close',
		description: 'Label for button to close the modal',
		id: 'townsquare.twc-onboarding-widget.twc-card.modal-close',
	},
});
